


















































import { Component, Vue, Watch, Prop } from "vue-property-decorator"

@Component
export default class enPaySheets extends Vue {
    @Prop({ type: [Object, Array] })
    data: any;
    employeeList: any = []
    salaryList: any = this.data;

    mounted() {
        this.getEmployList();
    }

    @Watch("data")
    dataChange(val: any) {
        this.salaryList = val;
    }

    //获取员工姓名
    getEmployList(then?: any) {
        Vue.axios
            .post(
                "dim/account/find",
                {
                    accountBookId: this.$store.state.accountBook.id,
                    dimAccountType: "员工"
                }
            )
            .then(res => {
                this.employeeList = res.data.dimEmployeeList;
                if (then) then();
            });
    }
    getEmploy(id: string) {
        for (let i = 0; i < this.employeeList.length; i++) {
            if (this.employeeList[i].id === id) {
                return this.employeeList[i].name;
            }
        }
        return;
    }
}
